import { cn } from '@/utlis/cn'

type CardHeaderProps = {
    icon: React.ComponentType<{ style?: React.CSSProperties }>
    title: string
    className?: string
}
export function CardHeader(props: CardHeaderProps) {
    return (
        <div className={cn('flex items-center gap-[16px]', props.className)}>
            <props.icon style={{ fontSize: '1.4rem' }} />
            <h3 className="t-lg-medium">{props.title}</h3>
        </div>
    )
}
